import React from "react";

export interface AudioPlayerContextI {
    src?: string;
    setSrc: (src: string) => void;
    playedSamples?: Set<string>;
    markSamplePlayed: (asin: string) => void;
}

const noOp = () => { /**/ };
const AudioPlayerContext = React.createContext<AudioPlayerContextI>({ setSrc: noOp, markSamplePlayed: noOp });

export default AudioPlayerContext;
